import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import { router } from './router'
import CoreuiVue from '@coreui/vue'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import { iconsSet as icons } from './assets/icons/icons.js'
import axios from 'axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret,faUsers,faHome,faChild,faUserTie,faUserPlus,faSeedling,faTrashAlt,faUserMinus,faExchangeAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import store from './store'
import moment from 'moment' 
import VueScriptComponent from 'vue-script-component'
library.add(faUserSecret,faUsers,faHome,faChild,faUserTie,faUserPlus,faSeedling,faTrashAlt,faUserMinus,faExchangeAlt)
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import Permissions from './mixins/permission.js'
import VueSmoothScroll from 'vue2-smooth-scroll'
import VueMeta from 'vue-meta'

Vue.use(VueSmoothScroll)
  
Vue.use(VueMeta)

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// This imports all the layout components such as <b-container>, <b-row>, <b-col>:
import { LayoutPlugin } from 'bootstrap-vue'
Vue.use(LayoutPlugin)

// This imports <b-modal> as well as the v-b-modal directive as a plugin:
import { ModalPlugin } from 'bootstrap-vue'
Vue.use(ModalPlugin)

// This imports <b-card> along with all the <b-card-*> sub-components as a plugin:
import { CardPlugin } from 'bootstrap-vue'
Vue.use(CardPlugin)

// This imports directive v-b-scrollspy as a plugin:
import { VBScrollspyPlugin } from 'bootstrap-vue'
Vue.use(VBScrollspyPlugin)

// This imports the dropdown and table plugins
import { DropdownPlugin, TablePlugin } from 'bootstrap-vue'
Vue.use(DropdownPlugin)
Vue.use(TablePlugin)

Vue.mixin(Permissions)

Vue.prototype.moment = moment
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
Vue.component("tagicon",Icon)
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)
Vue.prototype.$http = axios;

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

axios.defaults.baseURL = process.env.VUE_APP_URL
//axios.defaults.baseURL = 'http://localhost:8005/api'

import { mapActions, mapGetters, mapState } from 'vuex'

//vue select with search 
import 'vue-search-select/dist/VueSearchSelect.css'

//start vue html to paper//--------------------------------------------------------
import VueHtmlToPaper from 'vue-html-to-paper';

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

Vue.use(VueHtmlToPaper, options);

// or, using the defaults with no stylesheet
Vue.use(VueHtmlToPaper);
//end vue html to paper//-------------------------------------------------------


// Vue editable grid component and styles
import VueEditableGrid from 'vue-editable-grid'
import 'vue-editable-grid/dist/VueEditableGrid.css'

// register component in the Vue app
Vue.component('vue-editable-grid', VueEditableGrid)



//COLOR PICKER START
import { Chrome } from 'vue-color'

Vue.component('colorpicker', {
	components: {
		'chrome-picker': Chrome,
	},
	template: `
<div class="input-group color-picker" ref="colorpicker">
	<input type="hidden" class="form-control" v-model="colorValue" @focus="showPicker()" @input="updateFromInput" />
	<span class="input-group-addon color-picker-container">
		<CButton class="btn btn-sm" type="button" @click="togglePicker()"  variant="outline" color="info">Pick Color</CButton>
		<chrome-picker :value="colors" @input="updateFromPicker" v-if="displayPicker" />
	</span>
</div>`,
	props: ['color'],
	data() {
		return {
			colors: {
				hex: '#000000',
			},
			colorValue: '',
			displayPicker: false,
		}
	},
	mounted() {
		//this.setColor(this.color || '#000000');
    this.setColor(this.color);
	},
	methods: {
		setColor(color) {
			this.updateColors(color);
			this.colorValue = color;
		},
		updateColors(color) {
			if(color.slice(0, 1) == '#') {
				this.colors = {
					hex: color
				};
			}
			else if(color.slice(0, 4) == 'rgba') {
				var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
					hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
				this.colors = {
					hex: hex,
					a: rgba[3],
				}
			}
		},
		showPicker() {
			document.addEventListener('click', this.documentClick);
			this.displayPicker = true;
		},
		hidePicker() {
			document.removeEventListener('click', this.documentClick);
			this.displayPicker = false;
		},
		togglePicker() {
			this.displayPicker ? this.hidePicker() : this.showPicker();
		},
		updateFromInput() {
			this.updateColors(this.colorValue);
		},
		updateFromPicker(color) {
			this.colors = color;
			if(color.rgba.a == 1) {
				this.colorValue = color.hex;
			}
			else {
				this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
			}
		},
		documentClick(e) {
			var el = this.$refs.colorpicker,
				target = e.target;
			if(el !== target && !el.contains(target)) {
				this.hidePicker()
			}
		}
	},
	watch: {
		colorValue(val) {
			if(val) {
				this.updateColors(val);
				this.$emit('input', val);
				//document.body.style.background = val;
			}
		}
	},
});
//COLOR PICKER END

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  },
  computed: {
    ...mapGetters(['isAuth']),
    ...mapState(['token']),
    ...mapState('user', {
        user_authenticated: state => state.authenticated
    })
  },
  methods: {
      ...mapActions('user', ['getUserLogin']),
      //...mapActions('notification', ['getNotifications']),
      //...mapActions('expenses', ['getExpenses']),
      initialLister() {
          
      }
  },
  watch: {
      token() {
          this.initialLister()
      },
      user_authenticated() {
          this.initialLister()
      }
  },
  created() {
      if (this.isAuth) {
          this.getUserLogin()
          this.initialLister()
          //this.getNotifications()
      }
  }
})
